import styled from 'styled-components';
import {
  Menu as MenuComponent,
} from '@pearsontechnology/aero-components';
import { Title } from 'Workspace/components/WorkspaceHeader/styles';

export const KnowledgeMapTitleWrapper = styled(Title)`
  font-size: 32px;
  line-height: 43px;
`;
export const KnowledgeMapHeader = styled.div`
  float: right;
`;
export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
  width: 120px;
`;
export const MenuListItemText = styled.div`
  margin: 0 4px;
`;
export const CompetencyDocumentObjectivesWrapper = styled.span`
  font-weight: 600;
  font-size: 14px;
  margin-left: 25px;
`;
export const CompetencyDocumentObjectivesCount = styled.span`
  font-size: 22px;
  margin-right:5px;
`;
